import React, { useState, useEffect } from 'react'

import classes from './Collapse.scss'
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const Collapse = ({ show, title, style, children }) => {
  const [isCollapse, setIsCollapse] = useState(show)

  useEffect(() => {
    animate(!show)
  }, [show])

  const toggle = () => {
    setIsCollapse(!isCollapse)
  }

  const animate = isCollapse => {
    setIsCollapse(isCollapse)
  }

  let bodyClass = [classes.CollapseBody]

  return (
    <ExpansionPanel expanded={isCollapse} onChange={toggle}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.Header}>
        <Typography>{title}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={bodyClass.join(' ')} style={style}>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default Collapse
